import { render } from "./NinatrennView.vue?vue&type=template&id=339c9e28"
import script from "./NinatrennView.vue?vue&type=script&lang=js"
export * from "./NinatrennView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__